import type { ApiClient, RequestOptions } from './client';
import type { ProductIntroRequest, ProductIntroResponse } from '@/types/product-intro';

export interface ProductIntroApi {
  search: (req: ProductIntroRequest, options?: RequestOptions) => Promise<ProductIntroResponse>;
}

export function createProductIntroApi(client: ApiClient): ProductIntroApi {
  return {
    search(req, options) {
      return client.post<ProductIntroResponse>('/api/product-intros/search', req, options);
    },
  };
}
